import App from "@/App.vue";

export default [
  {
    path: "/termo",
    name: "term",
    component: App,
    redirect: { name: "term accept" },
    children: [
      {
        path: "",
        name: "term accept",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/TermAccept.vue"),
        meta: {
          displayName: "Termo de Condições - Lockton",
          requiresAuth: true
        }
      }
    ]
  }
];
